import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'finder-upload-progress',
    templateUrl: './finder-upload-progress.component.html',
    styleUrls: ['./finder-upload-progress.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FinderUploadProgressComponent {
  @Input() status: 1 | 2 | 3 | 4 | 5;

  constructor() {
  }
}
